import { Theme } from "../data/style/Theme";
import { useNavigate } from "react-router-dom";
import * as routes from "../data/links/routes";
import { useEffect, useState, lazy } from "react";
import { errorTexts } from "../data/assets/texts";
import useScreenSize from "../context/ScreenContext";
import GenWodDisplay from "../components/GenWodDisplay";
import { useQuery, useMutation } from "@tanstack/react-query";
import { generateWorkout, saveWorkout } from "../api/workouts";
import RequestButton from "../components/buttons/RequestButton";
import { useNotifications } from "../context/NotificationContext";
import { getExerciseCategories, getWorkoutTypes } from "../api/helpers";
import {
  AllCenteredColumn,
  SecondaryTitle,
  scrollBar,
  MainText,
  SpacedRow,
  CenteredRow,
} from "../data/style/Style";
import {
  EXERCISE_CATEGORIES_DATA,
  WORKOUT_TYPES_DATA,
} from "../data/assets/arrays";

const Box = lazy(() => import("@mui/material/Box"));
const Stack = lazy(() => import("@mui/material/Stack"));

const Generator = () => {
  const navigate = useNavigate();
  const [typeId, setTypeId] = useState(1);
  const [error, setError] = useState(false);
  const [workout, setWorkout] = useState([]);
  let { enableNotification } = useNotifications();
  const [categoryId, setCategoryId] = useState(1);
  const { mobileDevice, size } = useScreenSize();
  let [width] = size;
  const [loading, setLoading] = useState(true);

  console.log(mobileDevice);
  useEffect(() => {
    generateWod();
  }, []);

  const { data: categories, isPending: categoriesPending } = useQuery({
    queryKey: ["exercise", "categories", "wodable"],
    queryFn: ({ signal }) => getExerciseCategories({ signal, wodable: 1 }),
    staleTime: 12 * 60 * 60 * 1000,
  });

  const { data: types, isPending: typesPending } = useQuery({
    queryKey: ["workout", "types"],
    queryFn: ({ signal }) => getWorkoutTypes({ signal }),
  });

  const { mutate: generate } = useMutation({
    mutationFn: generateWorkout,
    onSuccess: (response) => {
      setWorkout(response.data);
      setLoading(false);
    },
    onError: (error) => {
      setError(true);
      setLoading(false);
      if (error.response.status === 400) {
        enableNotification(error.response.data.message, "error");
        return;
      }

      if (error.response.status === 403) {
        navigate(routes.LOGIN);
        return;
      }

      if (error.response.status >= 500)
        enableNotification(errorTexts.system_error, "error");
    },
  });

  let generateWod = () => {
    setError(false);
    setLoading(true);
    generate({
      typeId,
      categoryId,
    });
  };

  const { mutate: save, isPending: isSaving } = useMutation({
    mutationFn: saveWorkout,
    onSuccess: (response) => {
      enableNotification(response.data.message, "success");
      generateWod();
    },
    onError: (error) => {
      if (error.response.status === 400) {
        enableNotification(error.response.data.message, "error");
        return;
      }

      if (error.response.status === 403) {
        navigate(routes.LOGIN);
        return;
      }

      if (error.response.status >= 500)
        enableNotification(errorTexts.system_error, "error");
    },
  });

  let saveWod = async () => {
    var workoutTypeId = workout.type_id;
    var timecap = workout.timecap;
    var female_timecap = workout.female_timecap;
    var structureId = workout.structure_id;
    var wodExercises = workout.exercises;
    var every = workout.every || 0;
    var rounds = workout.rounds || 0;
    var categoryId = workout.category_id;
    var projectedScore = workout.projected_score || 0;
    var femaleProjectedScore = workout.female_projected_score || 0;
    var rest = workout.rest;
    var created = 0;

    save({
      workoutTypeId,
      timecap,
      female_timecap,
      structureId,
      wodExercises,
      every,
      rounds,
      rest,
      categoryId,
      created,
      projectedScore,
      femaleProjectedScore,
    });
  };
  return (
    <Stack
      direction={"row"}
      height={"100%"}
      flexWrap={"wrap"}
      overflow={"auto"}
      sx={scrollBar}
      minHeight={!mobileDevice && "450px"}
      rowGap={2}
    >
      <Stack
        flex={width < 1000 || mobileDevice ? 1 : 0.5}
        minWidth={"300px"}
        gap={2}
      >
        <SecondaryTitle>Workout Type</SecondaryTitle>
        {!typesPending && (
          <Stack direction={"row"} flexWrap={"wrap"} gap={2}>
            {types.map((item) => {
              const icon = WORKOUT_TYPES_DATA.find(
                (type) => type.id === item.id,
              ).icon;
              return (
                <AllCenteredColumn
                  onClick={() => setTypeId(item.id)}
                  sx={{
                    minWidth: "100px",
                    cursor: "pointer",
                    width: "35%",
                    background:
                      item.id === typeId
                        ? `${item.color}22`
                        : Theme.palette.card,
                    border: 1,
                    borderRadius: 3,
                    borderColor:
                      item.id === typeId
                        ? `${item.color}55`
                        : Theme.palette.border,
                    p: 1,
                    transition: "300ms",

                    "&:hover": {
                      transform: "translateY(-2px)",
                    },
                  }}
                >
                  <span style={{ color: Theme.palette.text }}>{icon}</span>
                  <SecondaryTitle
                    sx={{
                      color: item.id === typeId && item.color + " !important",
                    }}
                  >
                    {item.name}
                  </SecondaryTitle>
                </AllCenteredColumn>
              );
            })}
          </Stack>
        )}
      </Stack>
      <Stack
        width={mobileDevice ? "100%" : "50%"}
        gap={2}
        flex={1}
        minWidth={"300px"}
        // minWidth={!mobileDevice && "400px"}
      >
        <SecondaryTitle>Workout</SecondaryTitle>
        <Stack
          width={mobileDevice ? "95%" : "80%"}
          height={"100%"}
          alignSelf={"center"}
          minWidth={!mobileDevice && "380px"}
        >
          <GenWodDisplay wod={workout} loading={loading} error={error} />
        </Stack>
        <SpacedRow
          width={mobileDevice ? "95%" : "80%"}
          alignSelf={"center"}
          gap={2}
          minWidth={!mobileDevice && "350px"}
        >
          <Box width={"45%"}>
            <RequestButton
              small={mobileDevice}
              text={"🆕 Generate"}
              onClick={generateWod}
              disabled={loading}
              activeRequest={loading}
              loadingText="Generating..."
            />
          </Box>
          <Box width={"45%"}>
            <RequestButton
              small={mobileDevice}
              text={"🔖 Save"}
              alt={true}
              onClick={saveWod}
              disabled={isSaving}
              activeRequest={isSaving}
              loadingText={"Saving..."}
            />
          </Box>
        </SpacedRow>
      </Stack>
      <Stack
        flex={width < 1000 || mobileDevice ? 1 : 0.5}
        minWidth={"300px"}
        gap={2}
      >
        <SecondaryTitle>Exercise Category</SecondaryTitle>
        {!categoriesPending && (
          <Stack direction={"row"} flexWrap={"wrap"} gap={2}>
            {categories.map((item) => {
              const icon = EXERCISE_CATEGORIES_DATA.find(
                (type) => type.id === item.id,
              ).icon;
              return (
                <CenteredRow
                  gap={1}
                  onClick={() => setCategoryId(item.id)}
                  sx={{
                    minWidth: "130px",
                    cursor: "pointer",
                    width: mobileDevice || width < 1000 ? "40%" : "70%",
                    background:
                      item.id === categoryId
                        ? `${Theme.palette.orange}22`
                        : Theme.palette.card,
                    border: 1,
                    borderRadius: 3,
                    borderColor:
                      item.id === categoryId
                        ? Theme.palette.orange
                        : Theme.palette.border,
                    p: mobileDevice ? 1 : 2,
                    transition: "300ms",

                    "&:hover": {
                      transform: "translateY(-2px)",
                    },
                  }}
                >
                  <span
                    style={{
                      color: Theme.palette.text,
                      fontSize: mobileDevice ? "0.8rem" : "1rem",
                    }}
                  >
                    {icon}
                  </span>
                  <MainText
                    fontSize={mobileDevice ? "0.8rem" : "1rem"}
                    sx={{
                      color:
                        item.id === categoryId &&
                        Theme.palette.orange + " !important",
                    }}
                  >
                    {item.name}
                  </MainText>
                </CenteredRow>
              );
            })}
          </Stack>
        )}
      </Stack>
    </Stack>
  );
};
export default Generator;
